import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Use cellcog.ai authDomain in production (with nginx proxy for /__/ path)
// Use default firebaseapp.com authDomain in development (no proxy needed)
const isProduction = process.env.NODE_ENV === 'production';

const firebaseConfig = {
  apiKey: "AIzaSyDrVR2rktn3xPbThNJNDf6mZTtESF5XMgA",
  authDomain: isProduction ? "cellcog.ai" : "noted-robot-430807-u8.firebaseapp.com",
  projectId: "noted-robot-430807-u8",
  storageBucket: "noted-robot-430807-u8.firebasestorage.app",
  messagingSenderId: "130729742621",
  appId: "1:130729742621:web:f613c23e44207dec6b91f4",
  measurementId: "G-Y0E74P8509"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// ---------------------------------------------------------------------------
// First-party auth REST proxy (CEL-1086).
//
// Ad blockers block identitytoolkit.googleapis.com by HOSTNAME, which kills
// email/password signup outright for users running one (the biggest measured
// signup-loss bucket: 17 events / 6 users in 14d). The custom authDomain above
// only routes the OAuth HANDLER (/__/auth/*) through cellcog.ai — the SDK's
// REST calls (signUp, signIn, token refresh) still went straight to Google.
// In production we point them at same-origin nginx proxies instead (see
// sh/cellcog/startup.sh):
//   /gauth/       -> https://identitytoolkit.googleapis.com/
//   /gauth-token/ -> https://securetoken.googleapis.com/
//
// auth.config.{apiHost,tokenApiHost} are read at REQUEST time by the SDK's
// URL builder (_getFinalTarget: plain `scheme://host + path` concat — verified
// in the installed build, so a path-suffixed host works). This is an
// internal-but-stable config surface: pinned against firebase ^10.13.0;
// re-verify _getFinalTarget still concats this way on major SDK upgrades.
// ---------------------------------------------------------------------------
const DIRECT_API_HOST = 'identitytoolkit.googleapis.com';
const DIRECT_TOKEN_API_HOST = 'securetoken.googleapis.com';
const PROXY_API_HOST = 'cellcog.ai/gauth';
const PROXY_TOKEN_API_HOST = 'cellcog.ai/gauth-token';

let authProxyActive = false;
if (isProduction) {
  auth.config.apiHost = PROXY_API_HOST;
  auth.config.tokenApiHost = PROXY_TOKEN_API_HOST;
  authProxyActive = true;
}

// If the PROXY itself is broken (nginx route missing/misconfigured), flip back
// to the direct Google hosts for the rest of the session so auth degrades to
// exactly the pre-proxy behavior instead of an outage.
export function revertToDirectAuthHosts() {
  if (!authProxyActive) return false;
  authProxyActive = false;
  auth.config.apiHost = DIRECT_API_HOST;
  auth.config.tokenApiHost = DIRECT_TOKEN_API_HOST;
  console.warn('[firebase] Auth proxy unreachable — reverted to direct Google auth hosts for this session.');
  return true;
}

// Wrap an auth call so a proxy failure retries ONCE against the direct hosts.
// network-request-failed with the proxy active is ambiguous (user offline vs
// proxy broken) — the direct retry disambiguates for free: offline users fail
// again exactly as before, proxy victims recover.
export async function withAuthProxyFallback(fn) {
  try {
    return await fn();
  } catch (error) {
    if (error?.code === 'auth/network-request-failed' && revertToDirectAuthHosts()) {
      return fn();
    }
    throw error;
  }
}
